// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/reset-password/:token\",\"regex\":\"^/reset-password/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/chat\",\"regex\":\"^/([^/]+)/chat$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/coach\",\"regex\":\"^/([^/]+)/coach$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/coach/:coachId\",\"regex\":\"^/([^/]+)/coach/([^/]+)$\",\"paramNames\":[\"companyId\",\"coachId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/custom-dashboard\",\"regex\":\"^/([^/]+)/custom-dashboard$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/customer/:phone\",\"regex\":\"^/([^/]+)/customer/([^/]+)$\",\"paramNames\":[\"companyId\",\"phone\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/dashboard\",\"regex\":\"^/([^/]+)/dashboard$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/game\",\"regex\":\"^/([^/]+)/game$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/insight\",\"regex\":\"^/([^/]+)/insight$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/recovery\",\"regex\":\"^/([^/]+)/recovery$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/recovery/sms-debug\",\"regex\":\"^/([^/]+)/recovery/sms-debug$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/settings\",\"regex\":\"^/([^/]+)/settings$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/settings/weekly-reports\",\"regex\":\"^/([^/]+)/settings/weekly-reports$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/settings/weekly-reports/:reportId\",\"regex\":\"^/([^/]+)/settings/weekly-reports/([^/]+)$\",\"paramNames\":[\"companyId\",\"reportId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/setup\",\"regex\":\"^/([^/]+)/setup$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/source\",\"regex\":\"^/([^/]+)/source$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/table\",\"regex\":\"^/([^/]+)/table$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/tech-performance\",\"regex\":\"^/([^/]+)/tech-performance$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/:companyId/test\",\"regex\":\"^/([^/]+)/test$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/checkout/billing/:companyId\",\"regex\":\"^/checkout/billing/([^/]+)$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/checkout/billing/:companyId/details\",\"regex\":\"^/checkout/billing/([^/]+)/details$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/checkout/contact-support/:companyId\",\"regex\":\"^/checkout/contact-support/([^/]+)$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/checkout/custom-checkout/:companyId\",\"regex\":\"^/checkout/custom-checkout/([^/]+)$\",\"paramNames\":[\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/checkout/success/:session_id\",\"regex\":\"^/checkout/success/([^/]+)$\",\"paramNames\":[\"session_id\"],\"hasOptionalPrefix\":false},{\"path\":\"/partner/:partnerId/:companyId\",\"regex\":\"^/partner/([^/]+)/([^/]+)$\",\"paramNames\":[\"partnerId\",\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/partner/:partnerId/:companyId/db\",\"regex\":\"^/partner/([^/]+)/([^/]+)/db$\",\"paramNames\":[\"partnerId\",\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/partner/:partnerId/:companyId/notifications\",\"regex\":\"^/partner/([^/]+)/([^/]+)/notifications$\",\"paramNames\":[\"partnerId\",\"companyId\"],\"hasOptionalPrefix\":false},{\"path\":\"/partner/:partnerId/:companyId/users\",\"regex\":\"^/partner/([^/]+)/([^/]+)/users$\",\"paramNames\":[\"partnerId\",\"companyId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/forgot-password\"},{\"path\":\"/login\"},{\"path\":\"/login-m\"},{\"path\":\"/register\"},{\"path\":\"/checkout/fail\"},{\"path\":\"/home\"},{\"path\":\"/geo-blocked\"},{\"path\":\"/health/ads\"},{\"path\":\"/sentry-example-page\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.8";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from "@sentry/nextjs";

const isProduction = process.env.NODE_ENV === "production";

Sentry.init({
  dsn: isProduction ? process.env.NEXT_PUBLIC_SENTRY_DSN : undefined,
  enabled: isProduction,

  ignoreErrors: [
    "Cannot read properties of undefined (reading 'value')",
    "Cannot read properties of undefined (reading 'domInteractive')",
    "Java object is gone",
    "java bridge method invokation error",
    "Cannot read properties of null (reading 'dispose')",
    "Mehtod not found",
    "ResizeObserver loop limit exceeded",
    "Network request failed",
    "Failed to fetch",
    "$a",
    /translate_http/,
    /el_main/,
  ],

  tracesSampleRate: isProduction ? 0.1 : 0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
  _experiments: {
    enableLogs: true,
  },
  integrations: [
    Sentry.replayIntegration({
      // Additional replay configuration goes in here, for example:
      maskAllText: false,
      blockAllMedia: true,
    }),
    Sentry.consoleLoggingIntegration({ levels: ["warn", "error"] }),
    // Note: Unhandled promise rejections are captured automatically by Sentry Next.js
    // Note: Browser tracing is enabled automatically by Sentry Next.js
  ],
  replaysSessionSampleRate: isProduction ? 0.1 : 0,
  replaysOnErrorSampleRate: 1.0,

  // Only send events in production
  beforeSend(event, hint) {
    if (!isProduction) return null;
    // Add page context
    if (typeof window !== "undefined") {
      event.contexts = {
        ...event.contexts,
        page: {
          url: window.location.href,
          path: window.location.pathname,
          search: window.location.search,
          hash: window.location.hash,
        },
      };

      // Add browser info
      event.contexts.browser = {
        name: navigator.userAgent,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
      };
    }

    return event;
  },

  // Capture breadcrumbs for better debugging
  beforeBreadcrumb(breadcrumb, hint) {
    // Add URL to all breadcrumbs
    if (typeof window !== "undefined") {
      breadcrumb.data = {
        ...breadcrumb.data,
        url: window.location.href,
      };
    }
    return breadcrumb;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
